import React from 'react';
import { SkeletonLine } from 'src/components/Helpers/SkeletonLine';

import classes from './BlogPostLoading.scss';

export const BlogPostLoading: React.FC = React.memo(() => (
    <div className={classes.wrapper}>
        <div className={classes.header}>
            <SkeletonLine width={20} />
            <SkeletonLine width={10} />
            <SkeletonLine width={7} />
        </div>
        {[...Array(10).keys()].map((key) => (
            <div key={key}>
                <SkeletonLine />
            </div>
        ))}
    </div>
));
